import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import requireIf from 'react-required-if';

import Icon from '../Atoms/Icon';

const propTypes = exact({
  fieldID: requireIf(PropTypes.string, (props) => props.labelText),
  handleChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  selectedValue: PropTypes.number.isRequired,
});

const defaultProps = {
  fieldID: null,
  labelText: null,
  maxValue: 10,
  minValue: 0,
};

class InputIncrement extends Component {
  constructor(props) {
    super(props);

    this.handleDecrementClick = this.handleDecrementClick.bind(this);
    this.handleIncrementClick = this.handleIncrementClick.bind(this);
  }

  handleDecrementClick() {
    const value = this.props.selectedValue - 1;
    if (value < this.props.minValue) return;
    this.props.handleChange(value, this.props.fieldID);
  }

  handleIncrementClick() {
    const value = this.props.selectedValue + 1;
    if (value > this.props.maxValue) return;
    this.props.handleChange(value, this.props.fieldID);
  }

  render() {
    return (
      <div className="InputIncrement">
        <div className="InputIncrement_field">
          <button
            type="button"
            className="InputIncrement_button"
            onClick={this.handleDecrementClick}
          >
            <Icon id="minus" />
          </button>
          <input
            id={this.props.fieldID}
            max={this.props.maxValue}
            min={this.props.minValue}
            onChange={() => false}
            value={this.props.selectedValue}
            className="InputIncrement_input"
          />
          <button
            type="button"
            className="InputIncrement_button"
            onClick={this.handleIncrementClick}
          >
            <Icon id="plus" />
          </button>
        </div>
        {this.props.labelText && (
          <label htmlFor={this.props.fieldID} className="InputIncrement_label">
            {this.props.labelText}
          </label>
        )}
      </div>
    );
  }
}

InputIncrement.propTypes = propTypes;
InputIncrement.defaultProps = defaultProps;

export default InputIncrement;
